module.exports = __webpack_public_path__ + "static/img/btn.5fdcc3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/instructions/img/btn.png
// module id = FO3O
// module chunks = 0